import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { routeNames } from 'src/modules/core/constants/routeNames'
import { AuthContext } from 'src/modules/user/context'

export function ForceLogout() {
  const navigate = useNavigate()
  const { logoutUser } = useContext(AuthContext)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.get('forceConsent') === 'true') {
      sessionStorage.setItem('forceConsentOnNextLogin', 'true')
    }

    logoutUser()
    navigate(routeNames.login.path, { replace: true })
  }, [logoutUser, navigate])

  return null
}
